<app-svg-icons></app-svg-icons>
<div class="platform_3dsource_com">
  <router-outlet></router-outlet>
</div>
